import AutocompleteFormik from "@/common/components/form/AutocompleteFormik";
import InputFormik from "@/common/components/form/InputFormik";
import { maskCurrency } from "@/common/helpers/mask.helpers";
import { getAllProducts } from "@/common/services/product.api";
import { IPurchaseOrder } from "@/types/purchaseOrder.types";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { FiTrash } from "react-icons/fi";
import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";

type Props = {
  index: number
  labelIsCounted: string
  labelIsNotCounted: string
  setRemoveIndex: (number: number) => void
  setShowConfirmModal: (bool: boolean) => void
  qtdComponentsPieces: number
}

function ProductEdit(props: Props) {


  const { values, setFieldValue } = useFormikContext<IPurchaseOrder>();

  const verifyIsCounted = (propState) => {

    if (!values.itens[props.index]) {
      return false;
    }

    const hasProductId = values.itens[props.index].productId
    if (propState == "isCounted" && hasProductId) {
      return true;
    }

    if (propState == "isNotCounted" && !hasProductId) {
      return true;
    }

    return false;
  }

  const [isCounted, setIsCounted] = useState<boolean>(verifyIsCounted("isCounted"));
  const [isNotCounted, setIsNotCounted] = useState<boolean>(verifyIsCounted("isNotCounted"));

  const [itens, setItens] = useState<{ productId: string, description: string }[]>([]);

  type Option = {
    value: string,
    label: string,
  };

  useEffect(() => {
    const fetchPieces = async () => {
      const response = (await getAllProducts()).data.map(product => ({ description: product.name, productId: product._id as string }));
      setItens(response);
    };
    fetchPieces();
  }, [props]);

  useEffect(() => {
    if (isCounted && isNotCounted) {
      setFieldValue(props.labelIsNotCounted, undefined);
      setFieldValue(props.labelIsCounted, undefined);
      setIsNotCounted(false);
      setIsCounted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCounted, isNotCounted]);

  const options: Option[] = [
    ...itens
      .map(item => ({
        label: item.description,
        value: item.productId,
      }))
  ];

  // Abre modal e salva índice
  const handleRemoveClick = (index: number) => {
    props.setRemoveIndex(index);
    props.setShowConfirmModal(true);
  };

  return (
    <tr key={props.index} id="componentProduct">
      <div className=" ml-2 mb-5 relative color flex items-center">
        <label htmlFor={props.labelIsCounted} className="block text-sm font-medium text-gray-600">

          {isCounted ? <div className="flex gap-2 items-center justify-start text-greenPrimary">
            <ImCheckboxChecked />
            <span>É movimento de estoque</span>
          </div>

            : <div className="flex gap-2 items-center justify-start">
              <ImCheckboxUnchecked />
              <span>É movimento de estoque</span>
            </div>}
          <input
            id={props.labelIsCounted}
            name={props.labelIsCounted}
            type="checkbox"
            checked={isCounted}
            onChange={() => {
              const newValue = !isCounted;
              setIsCounted(newValue);
              setFieldValue(props.labelIsCounted, newValue);
            }}
            className="border p-2 rounded w-full absolute opacity-0"
          />
        </label>

        <label htmlFor={props.labelIsNotCounted} className="ml-2 block text-sm font-medium text-gray-600">

          {isNotCounted ? <div className="flex gap-2 items-center justify-start text-redPrimary">
            <ImCheckboxChecked />
            <span>Não é movimento de estoque</span>
          </div>

            : <div className="flex gap-2 items-center justify-start">
              <ImCheckboxUnchecked />
              <span>Não é movimento de estoque</span>
            </div>}

          <input
            id={props.labelIsNotCounted}
            name={props.labelIsCounted}
            type="checkbox"
            checked={isNotCounted}
            onChange={() => {
              const newValue = !isNotCounted;
              setIsNotCounted(newValue);
              setFieldValue(props.labelIsCounted, false);
            }}
            className="border p-2 rounded w-full absolute opacity-0"
          />
        </label>
      </div>
      <td className="min-w-full">
        {isCounted ? <AutocompleteFormik
          label="Descrição da Compra:"
          name={`item${props.index}`}
          required={true}
          options={options.length > 0 ? options : []}
          className='w-small mt-1'
        />
          : <AutocompleteFormik
            label="Descrição da Compra:"
            name={`item${props.index}`}
            required={true}
            options={options.length > 0 ? options : []}
            className='w-small mt-1'
            allowNewItem={true}
          />
        }
      </td>
      <td>
        <InputFormik
          label=''
          name={`qtd${props.index}`}
          value={values[`qtd${props.index}`]}
          type="number"
        />
      </td>
      <td>
        <InputFormik
          label=''
          name={`value${props.index}`}
          mask={maskCurrency}
          value={values[`value${props.index}`]}
          className='w-[150px]'
        />
      </td>
      <td className="text-center">
        {props.qtdComponentsPieces > 1 && (
          <button
            type="button"
            onClick={() => handleRemoveClick(props.index)}
            className="p-2 rounded hover:bg-red-100"
            aria-label="Remover item"
          >
            <FiTrash className="text-red-500" size={22} />
          </button>
        )}
      </td>
    </tr>
  )
}

export default ProductEdit;